<template>
    <div class="world">
        <div class="world-bg"></div>
        <div class="world-globe">
            <div class="world-globe-pole"></div>
            <div class="world-globe-doms-container"></div>
            <div class="world-globe-halo">

            </div>
        </div>
        <div class="wrap-hud" :step="step">

            <div class="compat-wrap"
                 @click="showZonePin(index)"
                 v-for="(territory, index) in worldData.mainTerritory"
                 @mouseenter="hoverLinkEnter(index)"
                 @mouseleave="hoverLinkLeave(index)"
                 :class="{full: index === firstActiveMainTerritoryIndex,
                  hide : step === 2 && index !== firstActiveMainTerritoryIndex,
                  hovered: index === hoveredTerritoryIndex,
                   detail: isDetail}"
                 :style="'transform: translate('+territory.pinPosition.x+'px, '+territory.pinPosition.y+'px) scale(0.26)'">
                <div class="grill"></div>
                <div class="dotted-round"
                     :style="'transform: translate(-50%, -50%) rotate('+dottedRoundDeg+'deg)'"></div>
                <div class="solid-round"></div>
                <div class="quarter"
                     :style="'transform: translate(0, -100%) rotate('+quarterRoundDeg+'deg)'"></div>
                <div class="head-bar"
                     :style="'transform: translate(-50%, -50%) rotate('+barRoundDeg+'deg)'"></div>
            </div>


            <a class="pin-wrap"
                 v-for="(territory, index) in activeMainTerritoryPins"
                 :class="{'big-pin': territory.bigPin}"
                 :style="'top: '+territory.pinPosition.x+'px; left: '+territory.pinPosition.y+'px'"
                 :href="territory.link"
            >
                <div class="pin-grill"></div>
                <div class="pin-circle"></div>
                <div class="label" v-for="pin in territory.labels" :class="pin.position"><p v-html="pin.name"></p></div>
            </a>


        </div>

        <div class="wrap-content-text">
            <div class="container">
                <div class="wrap-content">
                    <div class="bloc-main-titles">
                        <h2 class="titre" @click="goBackGlobal()"><slot name="titre"></slot></h2>
                        <ul>
                            <li v-for="(territory, index) in worldData.mainTerritory">
                                <a href="" :class="{active: index === activeMainTerritoryIndex}"
                                   @mouseenter="hoverLinkEnter(index)"
                                   @mouseleave="hoverLinkLeave(index)"
                                   @click.prevent="showZone(index)" v-html="territory.name"></a>
                            </li>
                        </ul>
                    </div>
                    <div class="bloc-details" :class="{'is-detail' :showBlocDetails}">
                        <slot :name="activeMainTerritoryIndexForDetailsInfos"></slot>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import $ from "jquery";
    import WordlMap from "../../mixins/world-map"

    export default {
        mixins: [WordlMap],
        props: {
            worldData: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                isAnimating: false,
                isProd: true,
                step: 1,
                activeMainTerritoryIndex: null,
                activeMainTerritoryIndexForDetailsInfos: null,
                firstActiveMainTerritoryIndex: null,
                first: true,
                dottedRoundDeg: 0,
                quarterRoundDeg: 0,
                barRoundDeg: 0,
                isDetail: false,
                dottedInterval: null,
                quarterInterval: null,
                barInterval: null,
                showBlocDetails: false,
                hoveredTerritoryIndex: null,
            };
        },
        watch: {
            isTweening(newVal) {
                if (newVal === false) {

                    this.isDetail = true
                    this.showSubPins()
                    this.initSetIntervalDetail()
                    this.activeMainTerritoryIndexForDetailsInfos = this.activeMainTerritoryIndex

                    setTimeout(() => {
                        this.showBlocDetails = true
                    }, 100)

                } else {
                    this.isDetail = false
                }
            }
        },
        computed: {
            activeMainTerritoryPins() {
                return this.activeMainTerritoryIndex === null ? null : this.worldData.mainTerritory[this.activeMainTerritoryIndex].subPins
            },
            activeMainTerritoryWorldPosition() {
                return this.activeMainTerritoryIndex === null ? null : this.worldData.mainTerritory[this.activeMainTerritoryIndex].worldPosition
            },
        },
        methods: {
            hoverLinkEnter(index) {
                if (this.step === 2) {
                    return
                }
                this.hoveredTerritoryIndex = index
            },
            hoverLinkLeave(index) {
                if (this.step === 2) {
                    return
                }
                this.hoveredTerritoryIndex = null
            },
            showZonePin(index) {
                if (this.step === 1) {
                    this.showZone(index)
                }
            },
            goBackGlobal() {
                if (this.isAnimating || this.step === 1){
                    return
                }
                this.isAnimating = true
                this.step = 1
                this.first = true
                this.goTo(this.worldData.startPosition.lat, this.worldData.startPosition.lng, this.worldData.startPosition.zoom);
                this.showBlocDetails = false
                this.hideSubPins()
                this.clearSetIntervals()
                this.hoveredTerritoryIndex = null
                this.firstActiveMainTerritoryIndex = null
                this.activeMainTerritoryIndex = null
                this.activeMainTerritoryIndexForDetailsInfos = null
                setTimeout(() => {
                    this.isAnimating = false
                }, 1000)

            },
            showZone(index) {
                if (this.isAnimating || this.activeMainTerritoryIndex === index) {
                    return
                }
                this.showBlocDetails = false

                this.isAnimating = true

                this.hideSubPins()
                this.animateSwitchCompat()
                // delay(this.showSubPins, 3000)
                this.activeMainTerritoryIndex = index
                this.goTo(this.activeMainTerritoryWorldPosition.lat, this.activeMainTerritoryWorldPosition.lng, this.activeMainTerritoryWorldPosition.zoom);

                if (this.first) {
                    this.firstActiveMainTerritoryIndex = index
                    this.first = false
                }
                this.step = 2


            },
            hideSubPins() {
                $(".pin-wrap").removeClass("show")
            },
            showSubPins() {
                var timer = 100
                var $pins = $(".pin-wrap")
                var total = $pins.length;

                $pins.each((index, element) => {
                    setTimeout(() => {
                        $(element).addClass("show")

                        if (index === total - 1) {
                            this.isAnimating = false
                        }
                    }, index * timer)

                })

            },
            initSetIntervalDetail() {
                if (!this.first) {
                    this.clearSetIntervals()
                }
                // Dotted
                this.dottedInterval = setInterval(() => {
                    this.dottedRoundDeg = this.dottedRoundDeg + 0.5
                }, 10);
                // Quarter
                this.quarterInterval = setInterval(() => {
                    this.quarterRoundDeg = this.quarterRoundDeg - 0.5
                    // this.dottedRoundDeg = Math.floor(Math.random() * 360)
                }, 20);
                // Bar
                this.barInterval = setInterval(() => {
                    this.barRoundDeg = this.barRoundDeg + 0.5
                    // this.dottedRoundDeg = Math.floor(Math.random() * 360)
                }, 20);
            },
            initSetIntervalGlobal() {
                // Dotted
                this.dottedInterval = setInterval(() => {
                    this.dottedRoundDeg = this.dottedRoundDeg - 2
                }, 10);
                // Quarter
                this.quarterInterval = setInterval(() => {
                    this.quarterRoundDeg = this.quarterRoundDeg + 2
                    // this.dottedRoundDeg = Math.floor(Math.random() * 360)
                }, 20);
                // Quarter
                this.barInterval = setInterval(() => {
                    this.barRoundDeg = this.barRoundDeg - 4
                    // this.dottedRoundDeg = Math.floor(Math.random() * 360)
                }, 10);
            },
            clearSetIntervals() {
                clearInterval(this.dottedInterval);
                clearInterval(this.quarterInterval);
                clearInterval(this.barInterval);
            },
            animateSwitchCompat() {
                this.clearSetIntervals()
                this.initSetIntervalGlobal()

            }

        },
        mounted() {

        },
        destroyed() {
        }
    };
</script>
